import { createSlice } from '@reduxjs/toolkit';
import { fetchSchedules, fetchPropertySchedules } from "../../api/calendar/fetch";

export const fetchCalendarSlice = createSlice({
    name: 'calendar/fetch',
    initialState: {
        schedules: [],
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSchedules.pending, (state, action) => {
                state.request = true;
            })
            .addCase(fetchSchedules.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
                // @ts-ignore
                state.schedules = action.payload.data || action.payload;
            })
            .addCase(fetchSchedules.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload?.message || 'Failed to fetch schedules';
            })
            .addCase(fetchPropertySchedules.pending, (state, action) => {
                state.request = true;
            })
            .addCase(fetchPropertySchedules.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
                // @ts-ignore
                state.schedules = action.payload.data || action.payload;
            })
            .addCase(fetchPropertySchedules.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload?.message || 'Failed to fetch property schedules';
            })
    },
});

export const { cancelError, showError, showSuccess } = fetchCalendarSlice.actions

export default fetchCalendarSlice.reducer;
